import { render, staticRenderFns } from "./RichMenuStatus.vue?vue&type=template&id=7fe2f9f5&"
import script from "./RichMenuStatus.vue?vue&type=script&lang=js&"
export * from "./RichMenuStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports